module.exports = __webpack_public_path__ + "static/fd060f9f58eba40a3437351a41970ca66057d8d8ca8cdb1e1d332d968d7a9ad1-2b39cc3ecd9d44842bfab01f7adf1aa6.jpeg";